import React, { useState } from 'react';
import { MdArrowDropDown } from 'react-icons/md';

const DepartmentsMobileDropdown = ({ departments, activeDepartmentId, setActiveDepartmentId }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const activeDepartment = departments.find(dept => dept.id === activeDepartmentId);
  const activeDepartmentTitle = activeDepartment ? activeDepartment.title : 'Select a Department';

  const handleDepartmentClick = (id) => {
    setActiveDepartmentId(id);
    setMobileMenuOpen(false); 
  };

  return (
    <div className="md:hidden relative px-4 py-8">
      <button
        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        className="text-left transition-all duration-300 cursor-pointer font-bold text-3xl flex items-center text-white"
      >
        {activeDepartmentTitle}
        <span className="ml-2">
          <MdArrowDropDown className={`transition-transform duration-300 ${mobileMenuOpen ? 'rotate-180' : ''}`} />
        </span>
      </button>

      {mobileMenuOpen && (
        <div className="fixed top-0 left-0 w-full h-screen bg-gray-400 bg-opacity-70 backdrop-blur-md z-50 flex flex-col justify-center pl-4 font-">
          {departments.map((department) => (
            <button
              key={department.id}
              onClick={() => handleDepartmentClick(department.id)}
              className={`
                transition-all duration-300 cursor-pointer text-left py-2
                ${activeDepartmentId === department.id ? 'text-2xl text-mainBlue font-bold' : 'text-xl text-white'}
              `}
            >
              {department.title}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default DepartmentsMobileDropdown;